module.exports = {
  DUMMY_SLUG: 'dummy',
};
